<template>
    <div class="mobile-create">
        <el-card class="profile">
            <div slot="header" class="clearfix">
                <span class="text-info">管理员替用户创建云视频会议</span>
            </div>

            <div class="mt-3">
                <el-form :model="single" ref="MeetingForm" label-width="4em">
                    <el-row>
                        <el-col>
                            <el-form-item prop="user_id" label="账号:"
                                          :rules="user_id_rule">
                                <el-autocomplete v-model="single.user_id"
                                                 :fetch-suggestions="querySearchAsync"
                                                 placeholder="请输入用户账号"
                                                 :trigger-on-focus="false"
                                                 @select="handleSelect"
                                                 class="w-100"
                                                 clearable
                                ></el-autocomplete>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="user_name"
                                    label="姓名:"
                                    :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' },]">
                                <el-input v-model="single.user_name" placeholder="请输入姓名" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="email"
                                    label="邮箱:"
                                    :rules="[{ required: true, message: '请输入邮箱', trigger: 'blur' },
                                { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }]">
                                <el-input v-model="single.email" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                prop="mobile"
                                label="手机:">
                                <el-input v-model="single.mobile" placeholder="腾讯会议需要手机" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="room_groups"
                                    label="会组:" style="margin-bottom: 0; ">
                                <select v-model="single.group_id" placeholder="请选择会议室组" class="w-100 mobile-select">
                                    <option
                                            v-for="item in allRoomGroups"
                                            :key="item.id"
                                            :value="item.id">{{item.name}}
                                    </option>
                                </select>
                            </el-form-item>
                        </el-col>
                        <div class="mb-4">
                            <meeting-freebusy ref="meeting_busy"
                                              :h323="single.option_h323"
                                              @change='handleFreeChange'
                                              size="small"
                                              :jump="false"
                                              :group="single.group_id"
                                              :duration="single.duration"
                                              :time="single.meeting_time"
                                              :date="single.meeting_date"
                                              :id="single.id">
                            </meeting-freebusy>
                        </div>
                        <el-col>
                            <el-form-item prop="meeting_date" label="日期:"
                                          :rules="[{ required: true, message: '请输入日期', trigger: 'blur' }]">
                                <el-input class="w-100 bg-light" type="date" v-model="single.meeting_date"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="meeting_time"
                                    label="时间:"
                                    :rules="[{ required: true, message: '请输入时间', trigger: 'blur' }]">
                                <select v-model="single.meeting_time" class="mobile-select w-100"  >
                                    <option v-for="item in time_options"
                                            :key="item"
                                            :value="item">
                                        {{item}}
                                    </option>
                                </select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="duration"
                                    label="时长:"
                                    value-format="HH-mm-ss"
                                    :rules="[{ required: true, message: '请输入时长', trigger: 'blur' }]">


                                <select v-model="single.duration" class="mobile-select w-100">
                                    <option v-for="item in duration_options"
                                            :key="item.value"
                                            :value="item.value">
                                        {{item.label}}
                                    </option>
                                </select>

                            </el-form-item>

                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item
                                    prop="topic"
                                    label="主题:"
                                    :rules="[{ required: true, message: '请输入主题', trigger: 'blur' }]">
                                <el-input v-model="single.topic"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="usage"
                                    label="用途:">
                                <select v-model="single.usage"  class="w-100 mobile-select">
                                    <option
                                            v-for="item in preset.app.usages"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                    </option>
                                </select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="isTencentMeeting">
                            <el-form-item
                                prop="topic"
                                label="联席主持:">
                                <el-input v-model="single.assistants" placeholder="请输入联席主持人工号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-show="roomGroupPlatform != 4">
                            <el-form-item
                                    prop="password"
                                    label="密码:">
                                <el-input v-model="single.password" clearable
                                          placeholder="0-8位纯数字"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-show="isWelinkMeeting">
                            <el-form-item
                                prop="size"
                                label="规模:" >
                                <el-select v-model="single.size" placeholder="填写规模" class="w-100">
                                    <el-option
                                        v-for="item in sizes"
                                        :key="item"
                                        :label="item+'人'"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="5" type="flex">
                        <el-col class="flex-grow-1">
                            <div class="el-form-item">
                                <label class="el-form-item__label"
                                       style="width: 60px;color: #2196f3">参会者:
                                </label>
                                <div class="el-form-item__content" style="margin-left: 60px;">
                                    <div class="el-textarea">
                                        <div class="el-textarea__inner"
                                             style="min-height: 60px;">
                                            <div v-for="(item,index) in emails" :key="item.emails"
                                                 style="display: inline-block">
                                                {{index===0?'':', '}}{{item.name}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col class="flex-grow-0" style="width: 60px;">
                            <button style="width: 100%;height: 60px" type="button" class="btn btn-secondary"
                                    @click="handleAddressBook">
                                <i class="fa fa-address-book-o"></i>
                            </button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-row type="flex"
                                    style="flex-wrap: wrap; padding-left: 60px;justify-content: space-between">
                                <div style="min-width: 7em;margin-bottom: 10px;" v-show="4 != roomGroupPlatform">
                                    <el-switch v-model="single.waiting_room"
                                               @change="single.option_jbh = single.waiting_room?0:single.option_jbh"
                                               active-text="等候室"
                                               :active-value="1"
                                               :inactive-value="0">
                                    </el-switch>
                                </div>
                                <div style="min-width: 7em;margin-bottom: 10px;">
                                    <el-switch v-model="single.option_jbh"
                                               @change="single.waiting_room = single.option_jbh?0:single.waiting_room"
                                               active-text="提前参会"
                                               active-value="1"
                                               inactive-value="0">
                                    </el-switch>
                                </div>
                                <div style="min-width: 7em;margin-bottom: 10px;display:none;">
                                    <el-switch v-model="single.option_mute"
                                               active-text="静音入会"
                                               active-value="1"
                                               inactive-value="0">
                                    </el-switch>
                                </div>
                                <div style="min-width: 7em;margin-bottom: 10px;">
                                    <el-switch v-model="single.option_interpreter"
                                               active-text="开启同传"
                                               active-value="1"
                                               inactive-value="0">
                                    </el-switch>
                                </div>
                                <div style="min-width: 7em;margin-bottom: 10px;" v-if="isTencentMeeting">
                                    <el-switch v-model="single.option_live"
                                               active-text="开启直播"
                                               active-value="1"
                                               inactive-value="0">
                                    </el-switch>
                                </div>
                                <div style="min-width: 7em;margin-bottom: 10px;">
                                    <el-select v-model="single.auto_record" size="small" style="width: 120px"
                                               placeholder="选择录像方案">
                                        <el-option label="手动录制" :value="0"></el-option>
                                        <el-option label="自动本地" :value="1"></el-option>
                                        <el-option label="自动云端" :value="2"></el-option>
                                    </el-select>
                                </div>
                            </el-row>
                        </el-col>
                    </el-row>

                </el-form>
            </div>

            <el-row>
                <div class="line"></div>
                <el-button :loading="is_loading" class="mt-3" type="primary" @click="handleSubmit">
                    {{$organization.use_id?'创建会议':'创建并发通知给用户'}}
                </el-button>
            </el-row>

        </el-card>

        <address-book-picker :edit_mode="address_book_visible" :address_book="emails" @cancel="handleCancel"
                             :duration="single.duration"
                             :time="single.meeting_time"
                             @success="handleSuccess">
        </address-book-picker>

    </div>
</template>

<script>
    import MeetingFreebusy from "../../components/Meeting-FreeBusy";
    import AddressBookPicker from "../../components/address-book-mobile-picker";
    import CreateMixin from "../../common/mixins/front-create-mixin";

    export default {
        name: "create",
        components: {MeetingFreebusy, AddressBookPicker},
        mixins: [CreateMixin],
        data(){ return {
            time_options : []
        }},
        created() {
            for(let i=0;i<24;i++) {
                for(let j=0;j<60;j+=30) {
                    this.time_options.push( ('0'+i).substr(-2)+':'+('0'+j).substr(-2) );
                }
            }
        }
    }
</script>

<style lang="scss">
    .mobile-create {

        .mobile-select {
            height: 40px;
            border: 1px solid #e2e5ea;
            padding: 0 10px;
            background-color: white;
            width: 100%;
            color: #606266;
        }
    }

</style>
